export default "//yastatic.net/s3/distribution/pythia/frontend/_/5085aa131cd3e7208051cc2a62e6d532.svg";